import { render, staticRenderFns } from "./SectionContent.vue?vue&type=template&id=424205c6&scoped=true&"
import script from "./SectionContent.vue?vue&type=script&lang=js&"
export * from "./SectionContent.vue?vue&type=script&lang=js&"
import style0 from "./SectionContent.vue?vue&type=style&index=0&id=424205c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424205c6",
  null
  
)

export default component.exports